/*Flexi Box Bundle Script Code - Modified with Quantity Selector & Line Item Properties*/

document.addEventListener('DOMContentLoaded', function () {
  // Cache DOM elements
  const checkboxes = document.querySelectorAll("input[type='checkbox']");
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const submitBtn = document.getElementById('submit-btn');
  const counterEl = document.getElementById('total_product_count');
  const flexiBoxForm = document.getElementById('flexi-box-form');

  // Multi-step detection
  const isMultiStep = !!window.FLEXI_MULTI_STEP;
  const steps = window.FLEXI_STEPS || [];

  // Enable checkboxes after page load
  checkboxes.forEach(checkbox => checkbox.disabled = false);

  // Global counter for total selected quantity
  let totalQuantitySelected = 0;

  // Helper: Calculate total quantity (global)
  function calculateTotalQuantity() {
    let total = 0;
    quantityInputs.forEach(input => total += parseInt(input.value) || 0);
    return total;
  }

  // Helper: Calculate quantity for a specific step
  function calculateStepQuantity(stepIndex) {
    let total = 0;
    const stepEl = document.querySelector(`.flexi-step[data-step-index="${stepIndex}"]`);
    if (!stepEl) return 0;
    stepEl.querySelectorAll('.quantity-input').forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }

  // Helper: Get step mandatory limit for an element
  function getStepMandatory(el) {
    const stepEl = el.closest('.flexi-step');
    if (!stepEl) return mandatoryProducts;
    return parseInt(stepEl.dataset.stepMandatory) || mandatoryProducts;
  }

  // Helper: Get step total for an element's step
  function getStepTotal(el) {
    const stepEl = el.closest('.flexi-step');
    if (!stepEl) return calculateTotalQuantity();
    let total = 0;
    stepEl.querySelectorAll('.quantity-input').forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }

  // Bubble counter update function
  function updateBubbleCounter() {
    if (!counterEl) return;

    totalQuantitySelected = calculateTotalQuantity();
    const isLimitReached = (totalQuantitySelected === mandatoryProducts);

    counterEl.classList.remove('limit-reached', 'active-limit-reached');

    if (isLimitReached) {
      counterEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff" stroke="#fff" stroke-width="0.5"/></svg>`;
      counterEl.classList.add('active-limit-reached');
    } else if (totalQuantitySelected > 0) {
      counterEl.textContent = totalQuantitySelected;
    } else {
      counterEl.textContent = '';
    }
  }

  // Update step progress counters (multi-step only)
  function updateStepCounters() {
    if (!isMultiStep) return;
    steps.forEach(step => {
      const counter = document.getElementById(`step-counter-${step.index}`);
      if (counter) {
        const currentSpan = counter.querySelector('.flexi-step-counter-current');
        if (currentSpan) {
          currentSpan.textContent = calculateStepQuantity(step.index);
        }
      }
    });
  }

  // Store the initial input values of checkboxes in an object on page load
  const initProdValues = {};
  checkboxes.forEach(checkbox => {
    initProdValues[checkbox.id] = checkbox.value.trim();
  });

  // Helper: Show product added indicators
  function showAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(el => el.classList.remove("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.add("is-active"));
    productInfo.querySelectorAll(".flexibox-price").forEach(el => el.style.background = "linear-gradient(270deg,#FFFAF2,#d2ecd6)" );
  }

  // Helper: Hide product added indicators
  function hideAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(el => el.classList.add("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.remove("is-active"));
    productInfo.querySelectorAll(".flexibox-price").forEach(el => el.style.background = "linear-gradient(270deg,#fff,#d2ecd6)" );

  }

  // Helper: Show notification message
  function showNotificationMessage(productTitle) {
    document.querySelectorAll(".message-bar").forEach(bar => {
      bar.classList.remove("is-hidden");
      const span = bar.querySelector("p span");
      if (span) span.textContent = productTitle;
      setTimeout(() => {
        bar.classList.add("is-hidden");
        if (span) span.textContent = "";
      }, 2500);
    });
  }

  // Checkbox click functionality - switches to quantity selector
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("click", function () {
      const initProductValue = initProdValues[this.id];
      const currProductValue = this.value.trim();

      if (currProductValue !== initProductValue) {
        location.reload();
        return;
      }

      const productInfo = this.closest(".collection-item");
      if (!productInfo) return;

      if (this.checked) {
        this.closest('.add-to-box').classList.add('hidden');
        const quantitySelector = productInfo.querySelector('.quantity-selector');
        if (quantitySelector) {
          quantitySelector.classList.remove('hidden');
          const quantityInput = quantitySelector.querySelector('.quantity-input');
          if (quantityInput) {
            quantityInput.value = 1;
            createLineItems(quantityInput);
          }
        }

        showAddedIndicators(productInfo);
        const productTitle = this.value.split("/")[0];
        showNotificationMessage(productTitle);

        totalQuantitySelected = 1;
        updateAllStates();
      }
    });
  });

  // Quantity selector functionality
  document.addEventListener('click', function(e) {
    const isPlus = e.target.classList.contains('quantity-plus');
    const isMinus = e.target.classList.contains('quantity-minus');
    if (!isPlus && !isMinus) return;

    const input = isPlus ? e.target.previousElementSibling : e.target.nextElementSibling;
    if (!input) return;

    const currentValue = parseInt(input.value) || 0;

    // Per-step or global max calculation
    let maxAllowed;
    if (isMultiStep) {
      const stepMandatory = getStepMandatory(input);
      const stepTotal = getStepTotal(input);
      maxAllowed = stepMandatory - stepTotal + currentValue;
    } else {
      const total = calculateTotalQuantity();
      maxAllowed = mandatoryProducts - total + currentValue;
    }

    if (isPlus && currentValue < maxAllowed) {
      input.value = currentValue + 1;
      updateProductCounter(input);
      createLineItems(input);
      updateAllStates();
    } else if (isMinus) {
      if (currentValue > 1) {
        input.value = currentValue - 1;
        updateProductCounter(input);
        removeLineItem(input);
        updateAllStates();
      } else if (currentValue === 1) {
        resetProductToCheckbox(input);
      }
    }
  });

  // Helper: Reset product to checkbox
  function resetProductToCheckbox(input) {
    input.value = 0;
    const productInfo = input.closest('.collection-item');
    if (!productInfo) return;

    input.closest('.quantity-selector').classList.add('hidden');
    const checkbox = productInfo.querySelector("input[type='checkbox']");
    if (checkbox) {
      checkbox.checked = false;
      checkbox.disabled = false;
      checkbox.removeAttribute('disabled');
      checkbox.closest('.add-to-box').classList.remove('hidden');
    }
    productInfo.classList.remove('disabled-item');

    hideAddedIndicators(productInfo);
    removeAllLineItems(input);
    updateAllStates();
  }

  // Unified update function - calls all necessary updates
  // Track which steps were complete before current action
  let previousStepCompletion = {};

  function updateAllStates() {
    // Snapshot step completion BEFORE updating
    const currentCompletion = {};
    if (isMultiStep) {
      steps.forEach(step => {
        currentCompletion[step.index] = calculateStepQuantity(step.index) >= step.mandatory;
      });
    }

    updateBubbleCounter();
    updateStepCounters();
    updateSubmitButton();
    updateCheckboxAndQuantityStates();

    // Auto-scroll only if a step JUST became complete (wasn't complete before)
    if (isMultiStep) {
      let justCompleted = false;
      for (const step of steps) {
        if (currentCompletion[step.index] && !previousStepCompletion[step.index]) {
          justCompleted = true;
          break;
        }
      }
      if (justCompleted) autoScrollToIncompleteStep();
      previousStepCompletion = currentCompletion;
    }
  }

  // Auto-scroll to first incomplete step (called only when a step just completed)
  function autoScrollToIncompleteStep() {
    if (!steps.length) return;
    let firstIncomplete = null;
    for (const step of steps) {
      const stepTotal = calculateStepQuantity(step.index);
      if (stepTotal < step.mandatory) {
        if (!firstIncomplete) firstIncomplete = step.index;
      }
    }
    if (firstIncomplete) {
      const stepEl = document.querySelector(`.flexi-step[data-step-index="${firstIncomplete}"]`);
      if (stepEl) {
        const rect = stepEl.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight * 0.7) {
          stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }

  // Update product counter display
  function updateProductCounter(input) {
    const counter = input.closest('.collection-item')?.querySelector('.product_counter');
    if (counter) counter.textContent = input.value;
  }

  // Create line items for the product
  function createLineItems(input) {
    const quantity = parseInt(input.value) || 0;
    const property = input.getAttribute('data-property');
    const itemId = input.getAttribute('data-id');

    if (!property || !itemId || !flexiBoxForm) return;

    removeAllLineItems(input);

    for (let i = 1; i <= quantity; i++) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = `properties[_ITEM${itemId}_${i}]`;
      hiddenInput.value = property;
      hiddenInput.className = `line-item-${itemId}`;
      flexiBoxForm.appendChild(hiddenInput);
    }
  }

  // Remove one line item
  function removeLineItem(input) {
    const itemId = input.getAttribute('data-id');
    if (!itemId) return;

    const lineItems = document.querySelectorAll(`.line-item-${itemId}`);
    if (lineItems.length > 0) {
      lineItems[lineItems.length - 1].remove();
    }
  }

  // Remove all line items for a product
  function removeAllLineItems(input) {
    const itemId = input.getAttribute('data-id');
    if (!itemId) return;

    document.querySelectorAll(`.line-item-${itemId}`).forEach(item => item.remove());
  }

  // Update checkbox and quantity button states based on total quantity
  function updateCheckboxAndQuantityStates() {
    if (isMultiStep) {
      // Per-step validation for multi-step mode
      document.querySelectorAll('.flexi-step').forEach(stepEl => {
        const stepMandatory = parseInt(stepEl.dataset.stepMandatory) || 0;
        let stepTotal = 0;
        stepEl.querySelectorAll('.quantity-input').forEach(inp => {
          stepTotal += parseInt(inp.value) || 0;
        });
        const stepFull = stepMandatory > 0 && stepTotal >= stepMandatory;

        // Process all items in this step
        stepEl.querySelectorAll('.collection-item').forEach(item => {
          // Skip sold-out items (they stay disabled always)
          if (item.querySelector('.add-to-box.sold-out')) return;

          const checkbox = item.querySelector("input[type='checkbox']");
          const quantityInput = item.querySelector('.quantity-input');
          const itemQuantity = quantityInput ? parseInt(quantityInput.value) || 0 : 0;

          if (!checkbox) return;

          if (stepFull && !checkbox.checked && itemQuantity === 0) {
            // Step is full and this item is NOT selected — disable it
            checkbox.disabled = true;
            checkbox.setAttribute('disabled', '');
            item.classList.add('disabled-item');
          } else {
            // Step NOT full, or item is currently selected — FORCE enable
            checkbox.disabled = false;
            checkbox.removeAttribute('disabled');
            item.classList.remove('disabled-item');
          }
        });

        // Disable/enable quantity plus buttons within this step
        stepEl.querySelectorAll('.quantity-plus').forEach(btn => {
          const input = btn.previousElementSibling;
          if (input) {
            const currentValue = parseInt(input.value) || 0;
            const maxAllowed = stepMandatory - stepTotal + currentValue;
            const shouldDisable = currentValue >= maxAllowed;
            btn.disabled = shouldDisable;
            btn.classList.toggle('disabled', shouldDisable);
          }
        });
      });
    } else {
      // Single-step validation (original logic)
      const total = calculateTotalQuantity();
      const isLimitReached = (typeof mandatoryProducts !== 'undefined' && total >= mandatoryProducts);

      // Disable/enable unchecked checkboxes
      checkboxes.forEach(checkbox => {
        if (!checkbox.checked) {
          const parentItem = checkbox.closest('.collection-item');
          if (parentItem) {
            const quantityInput = parentItem.querySelector('.quantity-input');
            const itemQuantity = quantityInput ? parseInt(quantityInput.value) || 0 : 0;
            const shouldDisable = isLimitReached && itemQuantity === 0;
            checkbox.disabled = shouldDisable;
            parentItem.classList.toggle('disabled-item', shouldDisable);
          }
        }
      });

      // Disable/enable quantity plus buttons
      document.querySelectorAll('.quantity-plus').forEach(btn => {
        const input = btn.previousElementSibling;
        if (input) {
          const currentValue = parseInt(input.value) || 0;
          const maxAllowed = mandatoryProducts - total + currentValue;
          const shouldDisable = currentValue >= maxAllowed || isLimitReached;
          btn.disabled = shouldDisable;
          btn.classList.toggle('disabled', shouldDisable);
        }
      });
    }
  }

  // Update submit button visibility
  function updateSubmitButton() {
    if (!submitBtn) return;

    const total = calculateTotalQuantity();
    submitBtn.style.display = (typeof mandatoryProducts !== 'undefined' && total === mandatoryProducts) ? 'inline-block' : 'none';
  }

  // Disable right-click context menu
  document.addEventListener("contextmenu", e => e.preventDefault());

  // Disable F12 key (Inspect Element)
  document.addEventListener("keydown", e => {
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
  });

  // Initial state check on page load
  updateAllStates();

  // ===== FILTER TAB LOGIC — per-collection subcategory filters =====
  document.addEventListener('click', function(e) {
    const tab = e.target.closest('.flexi-col-filter-tab');
    if (!tab) return;

    const filterContainer = tab.closest('.flexi-collection-filter');
    if (!filterContainer) return;

    const filter = tab.dataset.filter;
    const isActive = tab.classList.contains('active');

    // If clicking X on active tab or clicking active tab again — deselect (show all)
    if (isActive) {
      tab.classList.remove('active');
      const collectionSection = tab.closest('.collection-section');
      if (collectionSection) {
        collectionSection.querySelectorAll('.collection-item').forEach(item => {
          item.style.display = '';
        });
      }
      return;
    }

    // Deselect others, activate this one
    filterContainer.querySelectorAll('.flexi-col-filter-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    // Find the parent collection-section
    const collectionSection = tab.closest('.collection-section');
    if (!collectionSection) return;

    // Filter products within this collection only
    collectionSection.querySelectorAll('.collection-item').forEach(item => {
      const subcategory = item.dataset.subcategory || '';
      item.style.display = (subcategory === filter) ? '' : 'none';
    });
  });
});

/*Flexi Box Bundle - Gokwik Submit Handler*/
window.addEventListener('DOMContentLoaded', () => {
  const submitBtn = document.getElementById('submit-btn');
  const flexiBoxForm = document.getElementById('flexi-box-form');
  if (!submitBtn || !flexiBoxForm) return;

  // Use capture=true to run this BEFORE any bubble phase listeners (like gokwik)
  // Then stopImmediatePropagation will prevent gokwik from running
  submitBtn.addEventListener('click', (event) => {
    // Always prevent default and stop propagation first to block other handlers
    event.preventDefault();
    event.stopImmediatePropagation();

    // Skip if already processing (prevent duplicate execution)
    if (window.flexi_bundle_already_processing) {
      return;
    }

    const checkedInputs = flexiBoxForm.querySelectorAll('input[type="checkbox"]:checked');
    const variantId = parseInt(flexiBoxForm.dataset.variantId);
    const parent_sku = flexiBoxForm.dataset.sku;
    const parent_price_paise = parseFloat(flexiBoxForm.dataset.price);

    const itemProperties = {};
    const bundleProperties = {};
    const itemsData = [];
    let total_regular_price_paise = 0;
    let bundleCounter = 2; // Start at 2 since parent is _bundle_product1

    // Add parent product as first bundle item
    bundleProperties['_bundle_product1'] = `${parent_sku}/0/1`;

    // Collect items with quantities
    checkedInputs.forEach(input => {
      if (input.value !== 'No') {
        const productInfo = input.closest('.collection-item');
        const quantityInput = productInfo?.querySelector('.quantity-input');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        const item_price_paise = parseInt(input.dataset.price);
        const sku = input.dataset.sku;

        itemsData.push({ input, quantity, price_paise: item_price_paise, sku });
        total_regular_price_paise += item_price_paise * quantity;
      }
    });

    // Calculate total individual items
    const totalItems = itemsData.reduce((sum, item) => sum + item.quantity, 0);

    // Validate: must match mandatory product count before submitting
    if (typeof mandatoryProducts !== 'undefined' && totalItems !== mandatoryProducts) {
      alert(`Please select exactly ${mandatoryProducts} perfumes. You have selected ${totalItems}.`);
      return;
    }

    // Mark as processing only after validation passes
    window.flexi_bundle_already_processing = true;
    // Reset after 10 seconds to allow retry if something fails
    setTimeout(() => { window.flexi_bundle_already_processing = false; }, 10000);
    let currentItemIndex = 0;
    let allocated_price_paise = 0;
    let itemCounter = 1;

    // Process items with price allocation
    itemsData.forEach(itemData => {
      const { input, quantity, price_paise, sku } = itemData;

      for (let q = 0; q < quantity; q++) {
        itemProperties[`_ITEM${itemCounter}`] = input.value;

        const isLastItem = (currentItemIndex === totalItems - 1);
        let proportional_price_paise = isLastItem
          ? parent_price_paise - allocated_price_paise
          : Math.round((price_paise / total_regular_price_paise) * parent_price_paise);

        if (!isLastItem) allocated_price_paise += proportional_price_paise;

        const proportional_price_rupees = (proportional_price_paise / 100).toFixed(2);
        bundleProperties[`_bundle_product${bundleCounter}`] = `${sku}/${proportional_price_rupees}/1`;

        itemCounter++;
        bundleCounter++;
        currentItemIndex++;
      }
    });

    // Debug: track which handler ran and what quantities were read
    const debugQty = itemsData.map(d => `${d.sku}:qty${d.quantity}`).join('|');
    const properties = { ...itemProperties, ...bundleProperties, '_debug_handler': 'flexi-box-sticky', '_debug_quantities': debugQty, '_debug_totalItems': String(totalItems) };

    // Use Gokwik if available, otherwise fallback
    if (typeof onBuyNowClick === 'function') {
      onBuyNowClick(event, false, [{
        id: variantId,
        quantity: 1,
        properties: properties,
      }]);
    } else {
      // Fallback: Add properties to form and submit
      Object.entries(properties).forEach(([key, value]) => {
        if (!flexiBoxForm.querySelector(`input[name="properties[${key}]"]`)) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = `properties[${key}]`;
          hiddenInput.value = value;
          flexiBoxForm.appendChild(hiddenInput);
        }
      });
      flexiBoxForm.submit();
    }
  }, true); // true = use capture phase so this runs BEFORE gokwik's bubble handler
});

















